

import React from 'react'
import { Box, SxProps, Typography, styled } from '@mui/material'
import { status_employee } from '../../pages/cms/personnel-management/enum/enum-personnel';


type Props = {
    type: string;
    text: string;
    transform?: string;
    sx?: SxProps;
    style?: React.CSSProperties
    disableMaxWidth?: boolean
}
type colorType = {
    id: string;
    color: string;
}
const statusBgColor: colorType[] = [
    {
        id: 'รอการตรวจสอบยอดเงิน',
        color: "#ECF4FC"
    },
    {
        id: 'Pending Payment Verification',
        color: "#ECF4FC"
    },
    {
        id: 'รอการสอบ',
        color: "#ECF4FC"
    },
    {
        id: 'Awaiting Examination',
        color: "#ECF4FC"
    },
    {
        id: 'รอกำหนดแจ้งการสอบ',
        color: "#ECF4FC"
    },
    {
        id: 'Pending Exam Notification',
        color: "#ECF4FC"
    },
    {
        id: 'waiting',
        color: "#ECF4FC"
    },
    {
        id: 'จัดทำโครงการ',
        color: "#ECF4FC"
    },
    {
        id: 'ยอมรับ',
        color: "#ECF4FC"
    },
    {
        id: 'warning',
        color: "#FFFAF2"
    },
    {
        id: 'pending',
        color: '#ECF4FC'
    },
    {
        id: 'Pending Complaint',
        color: '#ECF4FC'
    },
    {
        id: 'อยู่ระหว่างตรวจสอบ',
        color: '#ECF4FC'
    },
    {
        id: 'Recommend',
        color: '#ECF4FC'
    },
    {
        id: 'รอผลสอบสัมภาษณ์',
        color: '#ECF4FC'
    },
    {
        id: 'Waiting for Interview Result',
        color: '#ECF4FC'
    },
    {
        id: 'รออนุมัติ',
        color: '#ECF4FC'
    },
    {
        id: 'หน่วยงานเสนอโครงการ',
        color: '#ECF4FC'
    },
    {
        id: 'รอการชำระเงินค่าเทอม',
        color: '#ECF4FC'
    },
    {
        id: 'Pending Tuition Payment',
        color: '#ECF4FC'
    },
    {
        id: 'เปิดให้จอง',
        color: '#ECF4FC'
    },
    {
        id: 'ตรวจไปบางส่วน',
        color: '#ECF4FC'
    },
    {
        id: 'approve',
        color: '#F3FFF6'
    },
    {
        id: 'อนุมัติ',
        color: '#F3FFF6'
    },
    {
        id: 'ผ่าน',
        color: '#F3FFF6'
    },
    {
        id: 'อนุมัติการจอง',
        color: '#F3FFF6'
    },
    {
        id: 'Passed',
        color: '#F3FFF6'
    },
    {
        id: 'ผ่านการตรวจสอบ',
        color: '#F3FFF6'
    },
    {
        id: 'ใช้งาน',
        color: '#F3FFF6'
    },
    {
        id: 'reject',
        color: '#FFF6ED'
    },
    {
        id: 'ชำระไม่ผ่าน',
        color: '#FFF6ED'
    },
    {
        id: 'ไม่ผ่านการพิจารณา',
        color: '#FFF6ED'
    },
    {
        id: 'Rejected',
        color: '#FFF6ED'
    },
    {
        id: 'ไม่อนุมัติ',
        color: '#FFF6ED'
    },
    {
        id: 'Complaint Rejected',
        color: '#FFF6ED'
    },
    {
        id: 'ปฎิเสธเรื่องร้องเรียน',
        color: '#FFF3E4'
    },
    {
        id: 'ไม่อนุมัติการจอง',
        color: '#FFF3E4'
    },
    {
        id: 'send_back',
        color: '#FFFAF2'
    },
    {
        id: 'รอรับเรื่องร้องเรียน',
        color: '#FFFAF2'
    },
    {
        id: 'hot',
        color: '#FFFAF2'
    },
    {
        id: 'กำลังดำเนินการ',
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการชำระเงิน',
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการคืน',
        color: '#FFFAF2'
    },
    {
        id: 'รอยืนยันการยืม',
        color: '#FFFAF2'
    },
    {
        id: 'Waiting for Approval',
        color: '#FFFAF2'
    },
    {
        id: 'รอรับคำร้อง',
        color: '#FFFAF2'
    },
    {
        id: 'ส่งทบทวนชำระเงิน',
        color: '#FFFAF2'
    },
    {
        id: 'อยู่ระหว่างการประชุม',
        color: '#FFFAF2'
    },
    {
        id: 'ยังไม่ถึงวันที่เปิดให้จอง',
        color: '#FFFAF2'
    },
    {
        id: 'approve',
        color: '#F3FFF6'
    },
    {
        id: "ดำเนินการแล้วเสร็จ",
        color: "#F3FFF6"
    },
    {
        id: "success",
        color: "#ECFDF3"
    },
    {
        id: "ผ่านสอบสัมภาษณ์",
        color: "#ECFDF3"
    },
    {
        id: "Interview Passed",
        color: "#ECFDF3"
    },
    {
        id: "กำลังยืม",
        color: "#ECFDF3"
    },
    {
        id: "ตรวจสอบยอดเงินแล้ว",
        color: "#ECFDF3"
    },
    {
        id: "Payment Verified",
        color: "#ECFDF3"
    },
    {
        id: "ทบทวนสรุปผล",
        color: "#FFF6ED"
    },
    {
        id: "คืนแล้ว",
        color: "#FFF6ED"
    },
    {
        id: "ส่งทบทวน",
        color: "#FFF6ED"
    },
    {
        id: "ส่งทบทวนยอดเงิน",
        color: "#FFF6ED"
    },
    {
        id: "Payment Verified",
        color: "#FFF6ED"
    },
    {
        id: "เป็นบุคลากร",
        color: '#ECFDF3'
    },
    {
        id: "ยืนยันการชำระเงินแล้ว",
        color: '#ECFDF3'
    },
    {
        id: "รับเรื่องร้องเรียน",
        color: '#ECF4FC'
    },
    {
        id: "ร่าง",
        color: '#ECF4FC'
    },
    {
        id: "นัดหมายการประชุม",
        color: '#ECF4FC'
    },
    {
        id: "อาจารย์ผู้สอนหลัก",
        color: '#F0F9FF'
    },
    {
        id: "อาจารย์ผู้สอนร่วม",
        color: '#ECF4FC'
    },
    {
        id: "Meeting Scheduled",
        color: '#ECF4FC'
    },
    {
        id: "รอตรวจสอบการชำระเงิน",
        color: '#ECF4FC'
    },
    {
        id: "ยังไม่ถึงกำหนดประชุม",
        color: '#ECF4FC'
    },
    {
        id: "รอชำระเงิน",
        color: '#ECF4FC'
    },
    {
        id: "บันทึกร่าง",
        color: '#FFFAEB'
    },
    {
        id: "รอตรวจสอบ",
        color: '#FFFAEB'
    },
    {
        id: "Pending Verification",
        color: '#FFFAEB'
    },
    {
        id: "รอพิจารณา",
        color: '#FFFAEB'
    },
    {
        id: "ยังไม่ได้ตรวจ / รอตรวจ",
        color: '#FFFAEB'
    },
    {
        id: "รับคำร้อง",
        color: '#FFFAEB'
    },
    {
        id: "Save Draft",
        color: '#FFFAEB'
    },
    {
        id: "สิ้นสุดการเป็นบุคลากร",
        color: '#FEF3F2'
    },
    {
        id: "new",
        color: '#FEF3F2'
    },
    {
        id: "เกินกำหนดระยะเวลา",
        color: '#FEF3F2'
    },
    {
        id: "ยกเลิก",
        color: '#FEF3F2'
    },
    {
        id: "ปฏิเสธคำร้อง",
        color: '#FEF3F2'
    },
    {
        id: "เลยกำหนดการประชุม",
        color: '#FEF3F2'
    },
    {
        id: "ดำเนินการเสร็จสิ้น",
        color: "#ECFDF3"
    },
    {
        id: "ตรวจเสร็จแล้ว",
        color: "#ECFDF3"
    },
    {
        id: "ไม่ผ่านการสอบ",
        color: '#FEF3F2'
    },
    {
        id: "ไม่ผ่านการตรวจสอบ",
        color: '#FEF3F2'
    },
    {
        id: "Exam Failed",
        color: '#FEF3F2'
    },
    {
        id: "ไม่ผ่านสอบสัมภาษณ์",
        color: '#FEF3F2'
    },
    {
        id: "Interview Failed",
        color: '#FEF3F2'
    },
    {
        id: "กำลังศึกษา",
        color: "#ECFDF3"
    },
    {
        id: "Currently Studying",
        color: "#ECFDF3"
    },
    {
        id: "ยืนยันนักศึกษา",
        color: "#ECFDF3"
    },
    {
        id: "Student Confirmed",
        color: "#ECFDF3"
    },
    {
        id: "ผ่านการสอบ",
        color: "#ECFDF3"
    },
    {
        id: "Exam Passed",
        color: "#ECFDF3"
    },
    {
        id: "เสร็จสิ้น",
        color: "#ECFDF3"
    },
    {
        id: "รับหนังสือแล้ว",
        color: "#ECFDF3"
    },
]
const statusTextColor: colorType[] = [
    {
        id: 'รอการตรวจสอบยอดเงิน',
        color: '#0A77FF'
    },
    {
        id: 'Pending Payment Verification',
        color: '#0A77FF'
    },
    {
        id: 'รอผลสอบสัมภาษณ์',
        color: '#0A77FF'
    },
    {
        id: 'Waiting for Interview Result',
        color: '#0A77FF'
    },
    {
        id: 'รอการสอบ',
        color: '#0A77FF'
    },
    {
        id: 'Awaiting Examination',
        color: '#0A77FF'
    },
    {
        id: 'รอกำหนดแจ้งการสอบ',
        color: '#0A77FF'
    },
    {
        id: 'Pending Exam Notification',
        color: '#0A77FF'
    },
    {
        id: 'waiting',
        color: '#0A77FF'
    },
    {
        id: 'จัดทำโครงการ',
        color: '#0A77FF'
    },
    {
        id: 'ยอมรับ',
        color: '#0A77FF'
    },
    {
        id: 'pending',
        color: '#0A77FF'
    },
    {
        id: 'รอชำระเงิน',
        color: '#0A77FF'
    },
    {
        id: 'Pending Complaint',
        color: '#0A77FF'
    },
    {
        id: 'อยู่ระหว่างตรวจสอบ',
        color: '#0A77FF'
    },
    {
        id: 'Recommend',
        color: '#0A77FF'
    },
    {
        id: 'รออนุมัติ',
        color: '#0A77FF'
    },
    {
        id: 'ส่งทบทวน',
        color: '#C4320A'
    },
    {
        id: 'ทบทวนสรุปผล',
        color: '#C4320A'
    },
    {
        id: 'คืนแล้ว',
        color: '#C4320A'
    },
    {
        id: 'รอการชำระเงินค่าเทอม',
        color: '#0A77FF'
    },
    {
        id: 'Pending Tuition Payment',
        color: '#0A77FF'
    },
    {
        id: 'หน่วยงานเสนอโครงการ',
        color: '#0A77FF'
    },
    {
        id: 'เปิดให้จอง',
        color: '#0A77FF'
    },
    {
        id: 'ตรวจไปบางส่วน',
        color: '#0A77FF'
    },
    {
        id: 'warning',
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวน',
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวนยอดเงิน',
        color: '#EEA23E'
    },
    {
        id: 'Payment Review Requested',
        color: '#EEA23E'
    },
    {
        id: 'ไม่ผ่านการพิจารณา',
        color: '#C8322B'
    },
    {
        id: 'Rejected',
        color: '#C8322B'
    },
    {
        id: 'reject',
        color: '#C8322B'
    },
    {
        id: 'ชำระไม่ผ่าน',
        color: '#C8322B'
    },
    {
        id: 'ไม่อนุมัติ',
        color: '#C8322B'
    },
    {
        id: 'Complaint Rejected',
        color: '#C8322B'
    },
    {
        id: 'ปฎิเสธเรื่องร้องเรียน',
        color: '#C8322B'
    },
    {
        id: 'ไม่อนุมัติการจอง',
        color: '#C8322B'
    },
    {
        id: 'ไม่ผ่านการสอบ',
        color: '#C8322B'
    },
    {
        id: 'ไม่ผ่านการตรวจสอบ',
        color: '#C8322B'
    },
    {
        id: 'Exam Failed',
        color: '#C8322B'
    },
    {
        id: 'ตรวจสอบยอดเงินแล้ว',
        color: '#2AA63C'
    },
    {
        id: 'Payment Verified',
        color: '#2AA63C'
    },
    {
        id: 'ตรวจเสร็จแล้ว',
        color: '#2AA63C'
    },
    {
        id: 'ยืนยันนักศึกษา',
        color: '#2AA63C'
    },
    {
        id: 'Student Confirmed',
        color: '#2AA63C'
    },
    {
        id: 'กำลังศึกษา',
        color: '#2AA63C'
    },
    {
        id: 'Currently Studying',
        color: '#2AA63C'
    },
    {
        id: 'approve',
        color: '#2AA63C'
    },
    {
        id: 'อนุมัติ',
        color: '#2AA63C'
    },
    {
        id: 'ใช้งาน',
        color: '#2AA63C'
    },
    {
        id: 'ผ่านสอบสัมภาษณ์',
        color: '#2AA63C'
    },
    {
        id: 'Interview Passed',
        color: '#2AA63C'
    },
    {
        id: 'กำลังยืม',
        color: '#2AA63C'
    },
    {
        id: 'ผ่านการสอบ',
        color: '#2AA63C'
    },
    {
        id: 'ผ่าน',
        color: '#2AA63C'
    },
    {
        id: 'Passed',
        color: '#2AA63C'
    },
    {
        id: 'ผ่านการตรวจสอบ',
        color: '#2AA63C'
    },
    {
        id: 'Exam Passed',
        color: '#2AA63C'
    },
    {
        id: 'close',
        color: '#FF8000'
    },
    {
        id: 'send_back',
        color: '#EEA23E'
    },
    {
        id: 'รอรับเรื่องร้องเรียน',
        color: '#EEA23E'
    },
    {
        id: 'hot',
        color: '#EEA23E'
    },
    {
        id: 'กำลังดำเนินการ',
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการชำระเงิน',
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการคืน',
        color: '#EEA23E'
    },
    {
        id: 'รอยืนยันการยืม',
        color: '#EEA23E'
    },
    {
        id: 'Waiting for Approval',
        color: '#EEA23E'
    },
    {
        id: 'รอรับคำร้อง',
        color: '#EEA23E'
    },
    {
        id: 'ส่งทบทวนชำระเงิน',
        color: '#EEA23E'
    },
    {
        id: "เป็นบุคลากร",
        color: '#0F9F0C'
    },
    {
        id: "ยืนยันการชำระเงินแล้ว",
        color: '#0F9F0C'
    },
    {
        id: "รับเรื่องร้องเรียน",
        color: '#0A77FF'
    },
    {
        id: "นัดหมายการประชุม",
        color: '#0A77FF'
    },
    {
        id: "อาจารย์ผู้สอนหลัก",
        color: '#026AA2'
    },
    {
        id: "อาจารย์ผู้สอนร่วม",
        color: '#0A77FF'
    },
    {
        id: "Meeting Scheduled",
        color: '#0A77FF'
    },
    {
        id: "ร่าง",
        color: '#0A77FF'
    },
    {
        id: "รอตรวจสอบการชำระเงิน",
        color: '#0A77FF'
    },
    {
        id: "ยังไม่ถึงกำหนดประชุม",
        color: '#0A77FF'
    },
    {
        id: "บันทึกร่าง",
        color: '#B54708'
    },
    {
        id: "Save Draft",
        color: '#B54708'
    },
    {
        id: "ยังไม่ถึงวันที่เปิดให้จอง",
        color: '#B54708'
    },
    {
        id: "รอตรวจสอบ",
        color: '#B54708'
    },
    {
        id: "Pending Verification",
        color: '#B54708'
    },
    {
        id: "รอพิจารณา",
        color: '#B54708'
    },
    {
        id: "ยังไม่ได้ตรวจ / รอตรวจ",
        color: '#B54708'
    },
    {
        id: "รับคำร้อง",
        color: '#B54708'
    },
    {
        id: "อยู่ระหว่างการประชุม",
        color: '#B54708'
    },
    {
        id: "สิ้นสุดการเป็นบุคลากร",
        color: '#B42318'
    },
    {
        id: "new",
        color: '#B42318'
    },
    {
        id: "เกินกำหนดระยะเวลา",
        color: '#B42318'
    },
    {
        id: "ยกเลิก",
        color: '#B42318'
    },
    {
        id: "ไม่ผ่านสอบสัมภาษณ์",
        color: '#B42318'
    },
    {
        id: "Interview Failed",
        color: '#B42318'
    },
    {
        id: "ปฏิเสธคำร้อง",
        color: '#B42318'
    },
    {
        id: "เลยกำหนดการประชุม",
        color: '#B42318'
    },
    {
        id: 'ดำเนินการเสร็จสิ้น',
        color: '#2AA63C'
    },
    {
        id: 'ผ่าน',
        color: '#2AA63C'
    },
    {
        id: 'อนุมัติการจอง',
        color: '#2AA63C'
    },
    {
        id: 'เสร็จสิ้น',
        color: '#2AA63C'
    },
    {
        id: 'รับหนังสือแล้ว',
        color: '#2AA63C'
    },
]
const StatusCustom: React.FC<Props> = (props: Props) => {
    const StatusContainer = styled(Box)({
        width: "100%",
        maxWidth: props.disableMaxWidth ? '' : 150,
        height: 30,
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        transform: props.transform ? props.transform : '',
        padding: "8px 8px",
        borderRadius: '16px',
        color: `${statusTextColor?.find((list) => list.id.toUpperCase() === props.type.toUpperCase())?.color} !important`,
        backgroundColor: statusBgColor?.find((list) => list.id.toUpperCase() === props.type.toUpperCase())?.color
    })

    return (
        <div className='flex justify-center'>
            <StatusContainer style={props.style} sx={{ ...props.sx }}>
                <li className='text-center'> {props.text}</li>
            </StatusContainer>
        </div>

    )
}

export default StatusCustom